<template>
  <div class="container">

    <el-row style="margin-bottom:20px">
        <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/director-work' }">工作台</el-breadcrumb-item>
        <el-breadcrumb-item>打卡</el-breadcrumb-item>
      </el-breadcrumb>
    </el-row>

    <div class="head">
        <img src="@/assets/director/workmaster/clock_in.png"></img>
        <div>
            <p class="title">兼职呗打卡</p>
            <p class="desc">打卡功能可以方便工作的管理，以及更加规范的办公体系，提高考勤效益，成员可在手机上轻松打卡，结合审批申请自动生成出勤报表。 支持固定时间上下班、灵活排班、自由上下班和外出打卡</p>
        </div>
    </div>

    <div class="cont">
      <p style="display: flex;justify-content: space-between;">
        <span style="font-weight:bold;">打卡设置列表</span>
        <span style="font-weight:bold;color:blue;cursor: pointer;" @click="clockList">统计报表</span>
      </p>
      <div class="clock-list">
          <div class="unit"  v-for="(item, index) in pageProps.records" :key="index">

              <div>
                <div class="title">项目：{{item.project_name}}</div>
                <div class="title">职位：{{item.job_name}}</div>  
                <div class="title">{{item.title}}</div>
              </div>
              
              <div class="op">
                 <span v-if="item.type==1||item.type==2">上下班打卡</span> 
                 <span v-if="item.type==3">外出打卡</span> 
                 <p class="btns"> 
                    <span @click="delClock(item)" style="cursor: pointer;">删除</span>
                    <span @click="editClock(item)" style="cursor: pointer;">编辑</span>
                </p>
              </div>
          </div>

      </div>

      <div style="text-align:center;padding:20px">
        <!--分页-->
        <el-pagination
          background
          layout="total, sizes, prev, pager, next, jumper"
          :total="pageProps.total"
          :page-size="pageProps.pageSize"
          :page-sizes="[5, 10, 50, 100]"
          :current-page="pageProps.pageNum"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
   


      <p style="font-weight:bold">添加打卡设置</p>
      <div class="edit-list">

        <div class="unit">
            <p class="title">上下班打卡</p>
            <p class="desc">跟随上下班时间，去定制合适的打卡时间</p>
            <p class="btns"> 
                  <span @click="addClock(1)" style="cursor: pointer;">设置</span>
              </p>
        </div>

        <div class="unit">
            <p class="title">外出打卡</p>
            <p class="desc">随时随地打卡，不限制地址，自由打卡</p>
            <p class="btns"> 
                  <span @click="addClock(2)" style="cursor: pointer;">设置</span>
              </p>
        </div>


      </div>

    </div>
    
  </div>
</template>

<script>
import { clockSetList,clockSetDel } from "@/api/director/clock/index.js";


export default {
    name: "Director-Work-CLock",
    data() {
      return {
       
        pageProps: {
          records:[],
          total: 0,
          pageSize: 10,
          pageNum: 1
        },

        searchFormData:{
          name:"",
          page:0,
          limit:0
        }

      }
    },

    mounted() {
      this.fetchData();
    },



    methods: {

      editClock(item){
        if(item.type==1){
          this.$router.push({path:'/director-workmaster-clock-edit-in',query:{id:item.id}});
        }else{
          this.$router.push({path:'/director-workmaster-clock-edit-out',query:{id:item.id}});
        }
      },

      delClock(item){
        var that=this;
        this.$confirm('确定删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          center: true
        }).then(() => {
          clockSetDel({id:item.id}).then((response) => {
              console.log(response);
              if(response.code==200){
                  that.fetchData();
                
              }
            });
          
        }).catch(() => {
        
        });
      },

      clockList(){
        this.$router.push({path:'/director-workmaster-clock-day',query:{}});
        
      },

      addClock(type){
        if(type==1){
          this.$router.push({path:'/director-workmaster-clock-edit-in',query:{}});
        }else{
          this.$router.push({path:'/director-workmaster-clock-edit-out',query:{}});
        }
      },


      fetchData(){
        var that = this;
        that.searchFormData.page=that.pageProps.pageNum;
        that.searchFormData.limit=that.pageProps.pageSize;

        clockSetList(that.searchFormData).then((response) => {
          console.log(response);
          if(response.code==200){
            that.pageProps.records = response.data.data;
            that.pageProps.total = response.data.total;
          }else{
            that.$message.error(response.msg?response.msg:"请求错误");
          }
         
        });
      },

       // 当前页变更
      handleCurrentChange(num) {
        this.pageProps.pageNum = num
        this.fetchData()
      },


      // 每页显示页面数变更
      handleSizeChange(size) {
        this.pageProps.pageSize = size
        this.fetchData()
      },
      
    }
  }
</script>
<style lang="scss" scoped>
::v-deep .main_box{
  background: #EEEBEC !important; 
}
.head{
  display: flex;
  justify-content: flex-start;
  background: #ffffff;
  box-shadow: 0px 0px 13px rgba(0,0,0,0.15);
  img{
    width: 120px;
    height: 120px;
    margin-right: 20px;
  }
  .title{
    margin-top: 20px;
    font-weight: bold;
    font-size: 20px;
  }
  .desc{
    margin-top: 10px;

  }
}

.cont{
  padding: 20px;
  box-shadow: 0px 0px 13px rgba(0,0,0,0.15);
  margin-top: 20px;

  .clock-list{
    display: flex;
    justify-content: space-between;
    margin-top: 10px;
    flex-flow: wrap;
 
    .unit{
      display: flex;
      justify-content: space-between;
      background: #F6F6F6;
      align-items: center;
      padding: 10px 30px;
      min-width: calc((100% - 160px) / 2);
      max-width: calc((100% - 160px) / 2);
      flex: 1;
      margin-bottom: 20px;

      .title{
        font-size: 14px;
        padding: 5px;
      }



      .job{
        max-width: 300px;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
      }

      .op{
        font-size: 14px;
        display:flex;
        align-items: center;
      }
      .btns{
        font-size: 14px;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        margin-left: 20px;
        span{
          line-height: 30px;
          text-align: center;
          border-radius: 4px;
          color: #4c71db;
          border: none;
          margin-left: 20px;
          background: none;
        }
      }
    }
  }


  .edit-list{
    display: flex;
    justify-content: space-between;
    margin-top: 10px;
    flex-flow: wrap;
 
    .unit{
      background: #F6F6F6;
      padding: 10px 30px;
      min-width: calc((100% - 160px) / 2);
      max-width: calc((100% - 160px) / 2);
      flex: 1;
      margin-bottom: 20px;

      .title{
        text-align: center;
      }

      .desc{
        text-align: center;
      }

      .btns{
        text-align: center;
        align-items: center;
        margin-left: 20px;
        span{
          line-height: 30px;
          text-align: center;
          border-radius: 4px;
          color: #4c71db;
          border: none;
          margin-left: 20px;
          background: none;
        }
      }
      


    }
  }
}
</style>